export default __webpack_public_path__ + "static/builder@2x-d37a8faa2b5500e0e8a49a56680c1d89.png";